var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account-circle",
    d: "M43.5,73.38A30.012,30.012,0,0,1,18.6,60.1c.124-8.3,16.6-12.865,24.9-12.865S68.276,51.8,68.4,60.1A30.012,30.012,0,0,1,43.5,73.38m0-58.93A12.45,12.45,0,1,1,31.05,26.9,12.45,12.45,0,0,1,43.5,14.45M43.5,2A41.5,41.5,0,1,0,85,43.5,41.5,41.5,0,0,0,43.5,2Z",
    transform: "translate(-2 -2)",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatar);
export default __webpack_public_path__ + "static/media/empty-avatar.b25868d5d240b5a91ddf1ae3cd3103fd.svg";
export { ForwardRef as ReactComponent };